<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b
          >PHỤ LỤC BIỂU PHÍ ÁP DỤNG CHÍNH SÁCH ƯU ĐÃI HOÀN PHÍ DÀNH CHO THẺ VISA PHÁT HÀNH TẠI VIỆT
          NAM</b
        >
      </p>
      <p class="txt-center">
        (Số:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          Hợp đồng hợp tác chấp nhận thanh toán số:
          <mark>{{
            dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
          }}</mark>
          <p>
            ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>{{
              dataContract.effectiveFromDTO
                ? dataContract.effectiveFromDTO
                : dataContract.dateSign | formatDate
            }}</mark>
          </p>
        </li>
      </ol>
      <ol class="form-style2">
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="fonsize-16 txt-tranf flex">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD:
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.name
              ? dataContract.saleInfoRes.name
              : ''
          }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.mobile
              ? dataContract.saleInfoRes.mobile
              : ''
          }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{ customerInfo.merchantName }}</b></mark
        >
      </p>
      <div class="form form-ext mb-4">
        <p>
          <span>Trụ sở: </span>
          <mark>
            {{ customerInfo.address }}, {{ customerInfo.district }},
            {{ customerInfo.city }}
          </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span
            class="ml-4"
            v-if="!(customerInfo && customerInfo.accIdType && customerInfo.accIdType === 'MOBILE')"
          >
            Email: {{ customerInfo.email }}
          </span>
        </p>
        <p>
          Tài khoản:<mark> {{ customerInfo.accountNo }}</mark>
        </p>
        <p>
          Tại:<mark> {{ customerInfo.bankName }}</mark>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p class="mb-4">
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>Hai bên cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>
      <p>&nbsp;</p>
      <ol class="form-style1">
        <li>
          <h1>Điều kiện áp dụng</h1>
          <p>
            Bên A thực hiện áp dụng ưu đãi bằng chính sách hoàn phí giao dịch cho Bên B khi Bên B
            chấp nhận thanh toán bằng thẻ <b>tín dụng quốc tế Visa phát hành tại Việt Nam</b> trong
            trường hợp Bên B có đầy đủ các điều kiện sau:
          </p>
          <ul>
            <li>
              Bên B là đơn vị kinh doanh vừa và nhỏ chỉ dùng 01 (một) thiết bị thanh toán thẻ của
              Bên A có Serial
              <mark
                ><b>
                  {{
                    dataAppendix.appendixVisa.deviceInfos[0]
                      ? dataAppendix.appendixVisa.deviceInfos[0].serialNumber
                      : '-'
                  }}</b
                ></mark
              >, (<i> không áp dụng với các đơn vị chuỗi hoặc đơn vị có thương hiệu </i>), được
              hưởng chính sách ưu đãi 01 (một) lần trong thời gian áp dụng chính sách hoàn phí (<i
                >căn cứ theo số giấy đăng ký kinh doanh để xác định </i
              >);
            </li>
            <li>
              Bên B ký Hợp đồng lần đầu tiên với Bên A và được kích hoạt trên hệ thống mPOS.vn kể từ
              ngày 05 tháng 09 năm 2023;
            </li>
            <li>
              Bên B có tổng sản lượng giao dịch thẻ Visa (<i
                >bao gồm thẻ Visa phát hành tại Việt Nam, thẻ Visa phát hành Nước ngoài, thẻ Visa
                các giao dịch Samsung pay, Google pay, Apple pay</i
              >) không vượt quá 1,8 tỷ VNĐ/01 năm kể từ ngày được chấp thuận tham gia chương trình
              ưu đãi này trên hệ thống mPOS.vn;
            </li>
            <li>
              Các giao dịch được Bên A hoàn phí cho Bên B là các giao dịch được thực hiện thành công
              bằng cách quẹt/cắm thẻ hoặc contactless thông qua thiết bị thanh toán thẻ của mPOS của
              Bên A cung cấp cho Bên B bằng thẻ thanh toán quốc tế mang thương hiệu Visa và phát
              hành tại Việt Nam (<i
                >áp dụng bao gồm cả giao dịch thanh toán thường và giao dịch trả góp</i
              >); các giao dịch này không bị ngân hàng tra soát hoặc khách hàng khiếu nại;
            </li>
            <li>
              Bên B kinh doanh ngành hàng thuộc đối tượng ưu đãi và được ngân hàng xử lý thanh toán
              thẩm định phê duyệt chính sách ưu đãi đối với ngành hàng này (Quy định tại
              <b>Mục 2</b>).
            </li>
          </ul>
        </li>
        <li>
          <h1>DANH SÁCH NGÀNH HÀNG ĐƯỢC ÁP DỤNG CHÍNH SÁCH ƯU ĐÃI</h1>
          <p>
            Phí được hoàn dựa theo ngành hàng kinh doanh của Bên B được ngân hàng xử lý thanh toán
            thẩm định áp dụng ưu đãi và được Bên A cấu hình trên hệ thống mPOS.vn. Mức phí ưu đãi
            theo các ngành hàng của chính sách hoàn phí cụ thể như sau:
          </p>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th><b>Nghành hàng</b></th>
                  <th><b>Phí mặc định</b></th>
                  <th><b>Mức phí hoàn</b></th>
                  <th><b>Phí sau hoàn</b></th>
                </tr>
              </thead>
              <tbody>
                <tr class="txt-center" v-for="(item, i) in dataTable" :key="i">
                  <td>
                    {{ item.category[0] }}<br /><i>{{ item.category[1] }}</i>
                  </td>
                  <td>{{ item.feeDefault }}</td>
                  <td>{{ item.feeReturn }}</td>
                  <td>
                    <b>{{ item.lastFeeReturn }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
            <p><b>Lưu ý:</b></p>
            <ol class="form-style2">
              <li>Đơn vị tính là VNĐ và đã bao gồm VAT.</li>
              <li>Số tiền được hoàn tối thiểu 10.000 VNĐ (Áp dụng lũy kế cho đến khi kết thúc).</li>
            </ol>
          </div>
        </li>
        <li>
          <h1>. NGUYÊN TẮC ÁP DỤNG</h1>
          <ul>
            <li>
              Bên B đáp ứng đầy đủ các điều kiện quy định tại <b>Mục 1</b> của Phụ lục Hợp đồng này.
            </li>
            <li>
              Mức phí được hoàn sẽ tính từ thời điểm tài khoản của Bên B được Ngân hàng chấp thuận
              tham gia chương trình theo quy định và Bên B nhận được thông báo của Bên A qua email
              hoặc qua các hình thức thông báo khác.
            </li>
          </ul>
        </li>
        <li>
          <h1>QUY ĐỊNH ĐỐI SOÁT, XUẤT HÓA ĐƠN, THANH TOÁN,:</h1>
          <ol>
            <ul>
              <li>
                Giao dịch đối soát hoàn phí: là các giao dịch trên hệ thống mPOS.vn đủ điều kiện của
                chương trình (quy định tại <b>Mục 1</b> của Phụ lục Hợp đồng này) mà Bên A đã thanh
                toán trả tiền cho Bên B về tài khoản ngân hàng từ 00h00’ ngày 25 tháng T-1 đến
                23h59’ ngày 24 tháng T.
              </li>
              <li>
                Thời gian gửi đối soát: Ngày 29 tháng T hàng tháng hoặc ngày làm việc kế tiếp nếu
                ngày 29 rơi vào ngày Thứ 7, Chủ nhật hoặc ngày nghỉ Lễ:
                <ol>
                  i. Nếu Bên B là Doanh nghiệp: Bên A gửi đối soát cho Bên B qua email
                </ol>
                <ol>
                  ii. Nếu Bên B khác Doanh nghiệp: Bên A cập nhật đối soát phí và Bên B theo dõi số
                  tiền phí giao dịch được hoàn trên trang website mpos.vn bằng tài khoản Bên B đã
                  đăng ký với Bên A.
                </ol>
                <ol>
                  Trong thời gian 03 (ba) ngày, nếu Bên B không có phản hồi hoặc thắc mắc về bản đối
                  soát này, Bên A sẽ ghi nhận số liệu và tiến hành thanh toán phí hoàn cho Bên B về
                  tài khoản ngân hàng của Bên B sử dụng để nhận tiền giao dịch chấp nhận thanh toán
                  trên hệ thống mPOS.vn của Bên A.
                </ol>
              </li>
              <li>
                Truy thu phí giao dịch đã được hoàn (đã được thanh toán) trong trường hợp phát sinh
                giao dịch cần hoàn trả: Trường hợp phát sinh các giao dịch cần hoàn trả lại tiền cho
                chủ thẻ, Bên A sẽ tiến hành truy thu phí đã hoàn (đã thanh toán) cho Bên B
              </li>
              <li>
                Thời gian thanh toán phí được hoàn: Bên A sẽ thanh toán cho Bên B phần phí hoàn
                trước ngày 10 của tháng T+1.
              </li>
            </ul>
          </ol>
        </li>
        <li>
          <h1>CHẤM DỨT PHỤ LỤC HỢP ĐỒNG</h1>
          <ul>
            <li>Visa hoặc Bên A có thông báo kết thúc áp dụng chính sách ưu đãi.</li>
            <li>
              Bên B được Bên A cấu hình áp dụng chương trình ưu đãi trên hệ thống mPOS.vn đủ 12
              tháng.
            </li>
            <li>
              Bên B vi phạm nghĩa vụ của mình theo quy định của Hợp đồng và không sửa chữa, khắc
              phục được vi phạm trong thời hạn do Bên A yêu cầu.
            </li>
            <li>
              Bên B vi phạm một trong các điều kiện hoặc nguyên tắc áp dụng theo quy định tại Phụ
              lục Hợp đồng này
            </li>
            <li>Các bên tiến hành thanh lý Hợp đồng chấp nhận thanh toán thẻ.</li>
            <li>
              Bên B có tổng sản lượng giao dịch thẻ Visa (<i
                >bao gồm thẻ Visa phát hành tại Việt Nam, thẻ Visa phát hành Nước ngoài, thẻ Visa
                các giao dịch Samsung pay, Google pay, Apple pay</i
              >) vượt quá 1,8 tỷ VNĐ/01 năm kể từ ngày được chấp thuận tham gia chương trình ưu đãi
              này trên hệ thống mPOS.vn
            </li>
          </ul>
          <p><b>Lưu ý:</b></p>
          <ol class="form-style2">
            <li>
              Việc chấm dứt Phụ lục hợp đồng này đồng nghĩa với việc Bên B sẽ không nhận được số
              tiền hoàn theo chương trình visa trong thời gian phát sinh của kỳ đối soát quy định
              tại khoản a Điều 4
            </li>
            <li>
              Đối với các trường hợp chấm dứt phụ lục hợp đồng do sự kiện a, b, f: Thời điểm chấm
              dứt phụ lục hợp đồng được tính từ khi phát sinh sự kiện
            </li>
            <li>
              Đối với các trường hợp chấm dứt phụ lục hợp đồng do sự kiện c, d, e: Thời điểm chấm
              dứt phụ lục hợp đồng được tính từ kỳ đối soát (quy định tại khoản a Điều 4) phát sinh
              sự kiện
            </li>
          </ol>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ul>
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện có thẩm quyền của hai Bên tham gia ký kết
              và được chấm dứt theo quy định tại Mục 5 của Phụ lục này.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ul>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {
        dataTable: [
          {
            category: ['Dịch vụ vận tải', '(Giao hàng, Taxi, Chuyển phát)'],
            feeDefault: '1.80%',
            feeReturn: '0.80%',
            lastFeeReturn: '1.00%',
          },
          {
            category: ['Xăng dầu, khí đốt', '(Cửa hàng xăng dầu)'],
            feeDefault: '1.80%',
            feeReturn: '0.80%',
            lastFeeReturn: '1.00%',
          },
          {
            category: ['Nhà hàng/Quán ăn, đồ uống', "(Nhà hàng, quán ăn, Cafe', Trà sữa)"],
            feeDefault: '1.80%',
            feeReturn: '0.60%',
            lastFeeReturn: '1.20%',
          },
          {
            category: [
              'Thời trang – Mỹ phẩm',
              '(Quần áo, Giày dép, Túi xách, Mũ / nón, đồng hồ, kính mắt, nước hoa, mỹ phẩm)',
            ],
            feeDefault: '1.80%',
            feeReturn: '0.60%',
            lastFeeReturn: '1.20%',
          },
          {
            category: ['Bán lẻ', '(Siêu thị, Mini Mart)'],
            feeDefault: '1.80%',
            feeReturn: '0.60%',
            lastFeeReturn: '1.20%',
          },
          {
            category: ['Giáo dục, đào tạo', '(Trường học, trung tâm đào tạo, khóa học ngắn hạn)'],
            feeDefault: '1.80%',
            feeReturn: '0.60%',
            lastFeeReturn: '1.20%',
          },
          {
            category: ['Điện tử, điện máy, điện thoại'],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: ['Spa – Thẩm mỹ'],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: ['Y tế', '(Nha khoa, Thiết bị y tế, nhà thuốc)'],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: ['Ô tô – Xe điện – Xe máy'],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: ['Yoga – Fitness', '(Trung tâm thể hình, Boxing, Aerobic, Zumba) '],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: [
              'Nội thất',
              '(Bàn ghế, Chăn ga gối đệm, Thiết bị vệ sinh, Thiết bị nhà bếp, Đèn trang trí, Sàn gỗ, Gạch ốp lát)',
            ],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: [
              'Dịch vụ giải trí',
              '(Khu vui chơi giải trí, Karaoke, Massage, Club/Bar/Pub)',
            ],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: ['Khách sạn – Lưu trú'],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          {
            category: ['Du lịch', '(Đại lý tour du lịch)'],
            feeDefault: '1.80%',
            feeReturn: '0.40%',
            lastFeeReturn: '1.40%',
          },
          { category: ['Bảo hiểm'], feeDefault: '1.80%', feeReturn: '-', lastFeeReturn: '1.80%' },
          { category: ['Dịch vụ'], feeDefault: '1.80%', feeReturn: '-', lastFeeReturn: '1.80%' },
          {
            category: ['Cơ khí, xây dựng'],
            feeDefault: '1.80%',
            feeReturn: '-',
            lastFeeReturn: '1.80%',
          },
          { category: ['Khác'], feeDefault: '1.80%', feeReturn: '-', lastFeeReturn: '1.80%' },
        ],
      }
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixVisas.find(e => e.isCreatedWithContract)
        )
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
